import { render, staticRenderFns } from "./PackagesFacets.vue?vue&type=template&id=8baf1aae&scoped=true"
import script from "./PackagesFacets.vue?vue&type=script&lang=js"
export * from "./PackagesFacets.vue?vue&type=script&lang=js"
import style0 from "./PackagesFacets.vue?vue&type=style&index=0&id=8baf1aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baf1aae",
  null
  
)

export default component.exports